import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/mogu-data';

export default function ArticlesPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '资讯中心' },
            ]}
          />

          <div className="mb-10">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              资讯中心
            </h1>
            <p className="mt-2 text-sm text-foreground-600">
              蘑菇tv最新动态、行业资讯与主播指南
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-16">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                    <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium">
                      {article.category}
                    </span>
                    <span>{article.date}</span>
                    <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                  </div>
                  <h2 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="mt-3 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}